const ServerUrl = process.env.API_HOST;
function chnup(event) {
  // return
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.open("POST", ServerUrl + "/open/third/kf/chat_track", true);
  var req_obj = {
    event: event,
  };
  req_obj = JSON.stringify(req_obj);
  xmlhttp.send(req_obj);
}
function download() {
  const param = new URLSearchParams(window.location.search);
  let url =
    "https://admin.happymoneyplant.com/test_8300/open/third/invite/down_url";
  // let url = ServerUrl + "/open/third/invite/down_url";

  if (!param.get("i")) {
    window.location.href =
      "https://d1fb2aqk1yyubf.cloudfront.net/apk365/com.payraja.app/PayRaja.apk";
    return;
  }

  url += "?code=" + encodeURIComponent(param.get("i"));
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      debugger;
      const response = JSON.parse(xhr.response);
      if (response.data.down_url) {
        window.location.href = response.data.down_url;
      }
    }
  };
  xhr.send();
}

export { chnup, download };



// WEBPACK FOOTER //
// ./src/utils/tools.js